var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout--default"},[_c('client-only',[_c('Header'),_c('FlashMessages'),_c('OverlayLoader')],1),_c('SiteContainer',[_c('Nuxt')],1),_c('Footer'),_c('LiveChat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }